import { useEffect, useState } from 'react';
import { apiModules } from '../../api/apiService';
import { Tag } from '../../api/Tag';
import { Author } from '../../api/Author';
import { sortAuthorsByFullName, sortTagsByName } from './recipeMetadata.helpers';

interface UseRecipeMetadataResult {
  allTags: Tag[];
  allAuthors: Author[];
  isLoadingTags: boolean;
  isLoadingAuthors: boolean;
}

interface RecipeMetadata {
  tags: Tag[];
  authors: Author[];
}

export const useRecipeMetadata = (): UseRecipeMetadataResult => {
  const [allTags, setAllTags] = useState<Tag[]>([]);
  const [allAuthors, setAllAuthors] = useState<Author[]>([]);
  const [isLoadingTags, setIsLoadingTags] = useState(true);
  const [isLoadingAuthors, setIsLoadingAuthors] = useState(true);

  useEffect(() => {
    const applyMetadata = ({ tags, authors }: RecipeMetadata) => {
      setAllTags(sortTagsByName(tags));
      setAllAuthors(sortAuthorsByFullName(authors));
    };

    const fetchMetaData = async (): Promise<RecipeMetadata> => {
      const [tags, authors] = await Promise.all([
        apiModules.tags.getUsedTags(),
        apiModules.authors.getAllAuthors(),
      ]);

      return { tags, authors };
    };

    const loadMetadata = async () => {
      try {
        applyMetadata(await fetchMetaData());
      } catch (error) {
        console.error('Erreur lors du chargement des metadonnées (tags/auteurs):', error);
      } finally {
        setIsLoadingTags(false);
        setIsLoadingAuthors(false);
      }
    };

    void loadMetadata();
  }, []);

  return {
    allTags,
    allAuthors,
    isLoadingTags,
    isLoadingAuthors,
  };
};

export default useRecipeMetadata;
